<div class="sam-full-width sam-full-height sam-form-flex-row">
   <div [ngClass]="isClearButtonVisible ? 'item-container sam-full-height' : 'sam-full-width sam-full-height'">
      <ng-container *ngIf="selectedEditorType.value === 'TEXT_EDITOR'">
         <div class="editor-center k-form-field sam-padding">
            <input
               fxFlex="1 1 auto"
               (input)="valueChangeString($event.target.value)"
               (debouncedInput)="valueChangeStringDebounced($event.target.value)"
               [value]="currentValue$ | async"
               [readOnly]="isEditorReadOnly"
               kendoTextBox
               class="text-editor"
               kendoTooltip
               showOn="none"
               [tooltipTemplate]="tooltipTemplate"
               #cellTooltipDirective="kendoTooltip"
               (mouseover)="showTooltip($event)"
               (mouseout)="hideTooltip()"
            />
         </div>
         <ng-template #tooltipTemplate let-anchor>
            <span>{{ currentValue$ | async }}</span>
         </ng-template>
      </ng-container>

      <ng-container *ngIf="selectedEditorType.value === 'NUMBER_EDITOR'">
         <div class="editor-center">
            <kendo-numerictextbox
               class="k-form-field sam-full-width sam-padding"
               (valueChange)="valueChangeNumeric($event)"
               (debouncedValueChange)="valueChangeNumericDebounced($event)"
               [value]="currentValue$ | async | stringToNumber"
               [format]="editorSettings | numberFormatConverter"
               [readonly]="isEditorReadOnly"
               [disabled]="isEditorReadOnly"
            ></kendo-numerictextbox>
         </div>
      </ng-container>

      <ng-container *ngIf="selectedEditorType.value === 'CHECK_BOX'">
         <button
            kendoButton
            class="sam-toggle-button sam-full-width sam-full-height"
            [class.k-state-active]="(currentValue$ | async) === editorSettings.checkboxValue"
            [togglable]="true"
            [disabled]="isEditorReadOnly"
            (click)="toggleButtonClicked($event, editorSettings)"
         >
            <fa-icon
               [icon]="
                  (currentValue$ | async) === editorSettings.checkboxValue
                     ? toggleButtonActiveIcon
                     : toggleButtonNonActiveIcon
               "
               size="lg"
            ></fa-icon>
         </button>
      </ng-container>
      <ng-container *ngIf="selectedEditorType.value === 'CHECK_BOX'">
         <button
            kendoButton
            class="sam-toggle-button"
            [class.k-state-active]="(editorValue$ | async) === editorSettings.checkboxValue"
            [style.height]="'100%'"
            [style.width]="'100%'"
            [togglable]="true"
            [disabled]="isEditorReadOnly$ | async"
            (click)="toggleButtonClicked($event, editorSettings)"
         >
            <fa-icon
               [icon]="
                  (editorValue$ | async) === editorSettings.checkboxValue
                     ? toggleButtonActiveIcon
                     : toggleButtonNonActiveIcon
               "
               size="lg"
            ></fa-icon>
         </button>
      </ng-container>

      <ng-container *ngIf="selectedEditorType.value === 'RICH_TEXT_EDITOR'">
         <ng-container *ngIf="!editorSettings.isPlaintextMode">
            <samweb-text-editor
               class="sam-full-width sam-full-height"
               [@displayHide]="
                  !isEditorReadOnly
                     ? {
                          value: 'show',
                          params: { display: 'contents', opacity: 1 }
                       }
                     : 'hide'
               "
               class="text-editor"
               [value]="currentValue$ | async"
               [smallView]="true"
               [useTheme]="true"
               (valueChange)="valueChangeHtml($event, 'body')"
               (debouncedValueChange)="valueChangeHtmlDebounced($event)"
            ></samweb-text-editor>
            <div
               class="sam-padding sam-full-width sam-full-height sam-auto-overflow"
               [@displayHide]="
                  isEditorReadOnly
                     ? {
                          value: 'show',
                          params: { display: 'contents', opacity: 1 }
                       }
                     : 'hide'
               "
               [style.overflow]="'auto'"
               [innerHTML]="isInputSafe ? (currentValue$ | async | safeHtml) : editorValue"
            ></div>
         </ng-container>

         <textarea
            *ngIf="editorSettings.isPlaintextMode"
            kendoTextArea
            class="sam-full-width sam-full-height"
            [autoSize]="false"
            (input)="valueChangeString($event.target.value)"
            (debouncedInput)="valueChangeStringDebounced($event.target.value)"
            [value]="currentValue$ | async"
            [readonly]="isEditorReadOnly"
         >
         </textarea>
      </ng-container>

      <ng-container *ngIf="selectedEditorType.value === 'SELECTOR'">
         <div class="editor-center k-form-field sam-padding">
            <kendo-dropdownlist
               fxFlex="1 1 auto"
               [data]="editorSettings | selectorValuesConverter"
               [value]="currentValue$ | async"
               (selectionChange)="valueChangeSelection($event)"
               [disabled]="isEditorReadOnly"
            ></kendo-dropdownlist>
         </div>
      </ng-container>
   </div>

   <div
      [@displayHide]="isClearButtonVisible ? 'show' : 'hide'"
      [@moveInAndOut]="isClearButtonVisible ? 'show' : 'right'"
   >
      <button
         class="sam-full-height clear-button-width"
         [disabled]="isEditorReadOnly"
         [look]="'flat'"
         [primary]="true"
         kendoButton
         (click)="clear()"
         (debouncedClick)="afterClear()"
         debouncedClickDelay="200"
      >
         <fa-icon [icon]="clearTagButtonIcon" size="lg"></fa-icon>
      </button>
   </div>
</div>
